import { tns } from 'tiny-slider/src/tiny-slider';
import Events from 'storefront/utilities/events';
import Slider from '../slider';

const CONTROLS_BUTTONS = '.slider__controls > button';

/**
 * FadeSlider class
 * @class FadeSlider
 * @extends {Slider}
 * @param {HTMLElement} element - The element to initialize as a FadeSlider component
 * @description Creates a new FadeSlider component that is based on the Slider component. This component has a fade effect on the slides on desktop and a carousel effect on mobile.
 *
 */
class FadeSlider extends Slider {
  constructor(element) {
    super(element);

    this.init();
  }

  init() {
    this.initFadingSlider();
  }

  initFadingSlider() {
    if (!this.numSlides || this.numSlides === 0) return;

    const isTabletOrBelow = window.innerWidth < 768;
    const hasControlsContainer = Boolean(this.controls);

    this.instance = tns({
      container: this.slider,
      items: '1',
      controls: hasControlsContainer,
      nav: false,
      controlsContainer: hasControlsContainer ? this.controls : false,
      mode: isTabletOrBelow ? 'carousel' : 'gallery', // mode doesn't work with responsive attribute so we need to set it manually
      mouseDrag: true,
      autoplay: false,
      autoplayButtonOutput: false,
      loop: false,
      autoHeight: true,
      onInit: () => this.initSliderEvent(),
      responsive: {
        768: {
          items: '1',
          mouseDrag: false,
          autoplay: true,
          autoplayTimeout: 200,
          controls: false,
          nav: false,
          animateIn: 'fadeInDown',
          animateOut: 'fadeOutDown',
          animateDelay: false,
          speed: 600
        },
      },
    });

    if (this.instance) {
      this.updateNavigation();
      this.bindDefaultEvents();

      if (!isTabletOrBelow) {
        this.element.addEventListener('mouseenter', () => {
          this.instance.play();
        });

        this.element.addEventListener('mouseleave', () => {
          this.instance.pause();
          this.instance.goTo('first');
        });
      }
    }

    // Check lazy load event, if image changes heights, reload the slider height
    Events.$on('image::loaded', (event, data) => {
      const updatedImage = data;
      const sliderImageData = this.imagesData.find(imageData => imageData.image === updatedImage);

      // If event image is in slider, and height has changed, reload slider height
      if (sliderImageData && sliderImageData.offsetHeight !== updatedImage.offsetHeight) {
        this.instance.updateSliderHeight();
      }
    });
  }

  /**
   * Event called after tiny-slider is initialized
   * It will pause the slider and bind click event to the navigation buttons
   * @returns {void}
   */
  initSliderEvent = () => {
    setTimeout(() => {
      this.instance.pause();
    }, 0);

    const controlsButtons = this.element.querySelectorAll(CONTROLS_BUTTONS);
    controlsButtons.forEach((button) => {
      button.addEventListener('click', (evt) => {
        evt.stopPropagation();
        evt.preventDefault();
        if (evt.currentTarget.getAttribute('data-controls') === 'next') {
          this.instance.goTo('next');
        } else {
          this.instance.goTo('prev');
        }
      });
    });
  }
}

export default FadeSlider;
